import { FormikHelpers } from 'formik';

import { FullProfile, PutSuccessResponse } from './model/types';

export async function submitFormWithUIFeedback<T>(
    profileValuesToSubmit: Partial<FullProfile>,
    helpers: FormikHelpers<T>,
    submitFn: (values: Partial<FullProfile>) => Promise<PutSuccessResponse>,
    formCompliantValues?: T
) {
    try {
        helpers.setStatus(undefined);
        helpers.setSubmitting(true);
        const response = await submitFn(profileValuesToSubmit);

        if (response.ok) {
            const valuesToResetFormWith = formCompliantValues || (profileValuesToSubmit as T);
            helpers.resetForm({ values: valuesToResetFormWith });
            helpers.setStatus({ success: true });
        } else {
            helpers.setStatus({ success: false, errorMessage: response.errorMessage });
        }
        helpers.setSubmitting(false);
    } catch (ex) {
        helpers.setSubmitting(false);
        console.error(ex);
        helpers.setStatus({ success: false, errorMessage: (ex as Error).message });
    }
}
